import { render, staticRenderFns } from "./NotesInfo.vue?vue&type=template&id=69c15342&scoped=true&"
import script from "./NotesInfo.vue?vue&type=script&lang=js&"
export * from "./NotesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c15342",
  null
  
)

export default component.exports